import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Component Imports
import { TemplatesComponent } from './Presentors/PageComponent/templates/templates.component';
import { TemplatesService } from './Presentors/PageComponent/templates/templates.service';
import { PreviewComponent } from './Presentors/PageComponent/preview/preview.component';
import { PreviewService } from './Presentors/PageComponent/preview/preview.service';
import { SendComponent } from './Presentors/PageComponent/send/send.component';
import { ResultComponent } from './Presentors/PageComponent/result/result.component';
import { StatusComponent } from './Presentors/PageComponent/status/status.component';
import { InviteLogsComponent } from './Presentors/PageComponent/status/invite-logs/invite-logs.component';
import { InviteStatusComponent } from './Presentors/PageComponent/status/invite-status/invite-status.component';
import { QuotesComponent } from './Presentors/PageComponent/quotes/quotes.component';
import { AttachmentsComponent } from './Presentors/PageComponent/attachment-pages/attachments/attachments.component';
import { BulkInviteComponent } from './Presentors/PageComponent/bulk-invite-pages/bulk-invite/bulk-invite.component';
import { BulkInviteTemplateComponent } from './Presentors/PageComponent/bulk-invite-pages/bulk-invite-template/bulk-invite-template.component';
import { AdminPageComponent } from './Presentors/PageComponent/admin-page/admin-page.component';
import { MaintenancePageComponent } from './Presentors/PageComponent/maintenance-page/maintenance-page.component';

// Attachment groups
import { AttachmentsGroupModule } from './Presentors/PageComponent/attachment-pages/attachments-group/attachments-group.module';
import { MergeAttachmentsModule } from './Presentors/PageComponent/attachment-pages/merge-attachments/merge-attachments.module';

// Component Module Imports
import { TemplateSettingsModule } from './Presentors/PageComponent/template-settings/template-settings.module';

// Shared Components
import { SharedComponentsModule } from './Presentors/SharedComponent/shared-components.module';
import { LoginFormComponent } from './Presentors/SharedComponent/login-form/login-form.component';
import { DropdownListComponent } from './Presentors/SharedComponent/dropdown-list/dropdown-list.component';
import { QueryBuilderComponent } from './Presentors/SharedComponent/query-builder/query-builder.component';
import { ClosePopupComponent } from './Presentors/SharedComponent/close-popup/close-popup.component';

// Shared Service
import { DataService } from './Services/Data/data.service';
import { HelperService } from './Services/HelperService/helper.service';

import { enableProdMode } from '@angular/core';
enableProdMode();

@NgModule({
  declarations: [
    AppComponent,
    TemplatesComponent,
    PreviewComponent,
    SendComponent,
    ResultComponent,
    StatusComponent,
    AttachmentsComponent,
    QuotesComponent,
    BulkInviteTemplateComponent,
    BulkInviteComponent,
    AdminPageComponent,
    ClosePopupComponent,
    LoginFormComponent,
    DropdownListComponent,
    InviteLogsComponent,
    InviteStatusComponent,
    QueryBuilderComponent,
    MaintenancePageComponent
  ],
  imports: [
    BrowserModule,
    SharedComponentsModule,
    CommonModule,
    AttachmentsGroupModule,
    MergeAttachmentsModule,
    TemplateSettingsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [TemplatesService, PreviewService, DataService, HelperService],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
